const TENGO_CRYPTO_METHODS = ['USDT', 'ETH', 'POLYGON'];

export const getTengoCryptoNetworks = (methods = {}) =>
  TENGO_CRYPTO_METHODS.filter(method =>
    Object.entries(methods || {}).some(([key, enabled]) =>
      key.toUpperCase() === method && enabled === true
    )
  );

// The payment carousel uses one crypto entry; the enabled networks live in its tabs.
export const getTengoCarouselMethods = (methods = {}) =>
  getTengoCryptoNetworks(methods).length > 0 ? ['USDT'] : [];

export const parseTengoUsdAmount = value =>
  Number(String(value || '').replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, ''));
